module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.edcea523.webp";